import React from "react";
import Joi from "joi-browser";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { Tabs, Tab } from "react-bootstrap";
import {
  getMarketGroup,
  addMarketGroup,
  updateMarketGroup,
} from "../../../common/services/markets/marketGroupService";
import MarketGroupMarkets from "./marketGroupMarkets";
import Form from "../../../common/components/form/form";
import Loading from "../../../common/components/loading/loading";
import MarketGroupHistory from "./marketGroupHistory";
import { withTranslation } from "react-i18next";

class MarketGroup extends Form {
  state = {
    data: {
      marketGroupId: "",
      name: "",
      active: "",
      eventId: "",
    },
    createdDate: "",
    updatedDate: "",
    errors: {},
    isLoading: true,
    isNew: true,
  };

  schema = {
    marketGroupId: Joi.string(),
    name: Joi.string().required().label(this.props.t("MarketGroupName")),
    active: Joi.boolean().label(this.props.t("Active")),
    eventId: Joi.string(),
  };

  async componentDidMount() {
    //try{
    const { marketGroupId, isNew } = this.props;
    this.setState({ isNew: isNew });
    var marketGroup = {};

    if (!isNew) {
      marketGroup = await getMarketGroup(marketGroupId);
      marketGroup.eventId = uuid();
    } //New User Add
    else {
      marketGroup = {
        marketGroupId: marketGroupId,
        name: "",
        active: true,
        eventId: uuid(),
      };
    }
    this.setState({ data: this.mapToViewModel(marketGroup), isLoading: false });

    const dateFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "numeric",
      hour: "numeric",
      hour12: false,
      minute: "numeric",
      second: "numeric",
    };

    this.setState({
      createdDate: new Date(marketGroup.createdDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
      updatedDate: new Date(marketGroup.updatedDate).toLocaleDateString(
        "en-US",
        dateFormatOptions
      ),
    });

    // }
    // catch(ex)
    // {
    //     //Handle Erorr..
    // }
  }

  mapToViewModel(marketGroup) {
    return {
      marketGroupId: marketGroup.marketGroupId,
      name: marketGroup.name,
      active: marketGroup.active,
      eventId: marketGroup.eventId,
    };
  }

  doSubmit = async () => {
    const { t, onRename } = this.props;
    const { isNew } = this.state;

    try {
      //Reset the event ID
      const data = { ...this.state.data };
      data.eventId = uuid();
      this.setState({ data: data });
      let response = {};

      if (!isNew) {
        response = await updateMarketGroup(this.state.data);
        toast.success(t("MarketGroupUpdated"));
      } else {
        response = await addMarketGroup(this.state.data);
        this.setState({ isNew: false });
        onRename(this.state.data.marketGroupId, this.state.data.name);
        toast.success(t("MarketGroupAdded"));
      }

      //Call back to the select list to allow it to update.
      this.props.submitCallbackFunction(response);
    } catch (ex) {
      console.log(t("ErrorSaving"), ex);

      if (ex.response && ex.response.status === 400) {
        var errorList = ex.response.data.errors;
        if (errorList) {
          var errorKeys = Object.keys(ex.response.data.errors);
          errorKeys.forEach(function (key) {
            errorList[key].map((error) => {
              toast.error(t("ErrorSaving") + " " + key + ": " + error);
              return null;
            });
          });
        } else {
          toast.error(t("ErrorSaving") + " " + ex.response.data);
        }
        const errors = { ...this.state.errors };
        errors.Name = ex.response.data;
        toast.error(ex.response.data.errors.title);
        this.setState({ errors });
      }
    }
  };

  render() {
    const { isLoading, isNew, createdDate, updatedDate } = this.state;

    if (isLoading) return <Loading />;

    const { t, marketGroupId, allowEdit } = this.props;

    return (
      <div className="container-fluid">
        <form className="form-inline" onSubmit={this.handleSubmit}>
          <fieldset disabled={allowEdit ? "" : "disabled"}>
            <div>
              {this.renderSwitch("active", t("Active"))}
              {this.renderInput("name", t("MarketGroupName"))}
              {allowEdit && this.renderButton(t("Save"))}
              <div className="form-footnote">
                {createdDate !== "Invalid Date" && (
                  <div>
                    {t("Created")} {createdDate}
                  </div>
                )}
                {updatedDate !== "Invalid Date" && (
                  <div>
                    {t("Updated")} {updatedDate}
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        </form>
        {!isNew && (
          <div>
            <Tabs
              className="nav-dark nav-tabs-sm"
              defaultActiveKey={1}
              id="useraccount-tabs"
              mountOnEnter={true}
              unmountOnExit={true}
            >
              <Tab eventKey={1} title={t("Markets")}>
                <MarketGroupMarkets
                  allowEdit={allowEdit}
                  marketGroupId={marketGroupId}
                />
              </Tab>
              <Tab eventKey={2} title={t("History")}>
                <MarketGroupHistory marketGroupId={marketGroupId} />
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation(["markets"])(MarketGroup);
